import React, { useEffect, useState, useRef } from "react";
import "./style.scss";
import { useStores } from "../../stores";
import moment from "moment";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import CentersListView from "../../components/CentersList/centerListView";
import Header from "../../components/Header";
import notify from "../../components/Notify/notify";
import MapIcon from "../../assets/images/map.svg";
import DateIcon from "../../assets/images/date.svg";
import CentreIcon from "../../assets/images/centre.svg";
import ValidateEmail from "../../components/Helper/emailValidate";
import { compareAsc, format } from "date-fns";
import Select from "../../components/Select";

let flag;

const FilterPage = () => {
  const location = useLocation();
  const mobiledateRef = useRef();
  const selectedFilterData = sessionStorage.getItem("selectedFilterData");
  const mobileAminities = sessionStorage.getItem("mobileAminities");
  let parseAminities =
    mobileAminities !== "undefined" && JSON.parse(mobileAminities);
  let parseData =
    selectedFilterData !== "undefined" && JSON.parse(selectedFilterData);
  const [filterData, setFilterData] = useState(parseData);
  const { bookingStore } = useStores();
  const [cityList, setCityList] = useState([]);
  const [selectedCity, setSelectedCity] = useState(
    parseData?.mobileSelectedCity
  );
  const [selectedCityLead, setSelectedCityLead] = useState("");
  const [centerList, setCenterList] = useState([]);
  const [selecteCenter, setSelecteCenter] = useState(parseData?.selecteCenter);
  const today = new Date();
  const todaydate = moment(today).format("YYYY-MM-DD");
  const date = moment(parseData?.mobileDate).format("YYYY-MM-DD");
  const [selectedDate, setSelectedDate] = useState(date);
  const [selectedDate2, setSelectedDate2] = useState("");
  const [dateChange, setDateChange] = useState(false);
  const [selecteSpace, setSelecteSpace] = useState([]);
  const [accessKey, setAccessKey] = useState("");
  const amenitiesArray = [
    { value: "VC", label: "VC" },
    { value: "LCD Screen", label: "LCD Screen" },
    { value: "Whiteboard", label: "Whiteboard" },
  ];
  const [selectedAminities, setSelectedAminities] = useState(
    parseAminities?.aminities
  );
  const [filtertime, setFiltertime] = useState([
    "8:00-12:00",
    "12:00-16:00",
    "16:00-20:00",
  ]);
  const [selectedfiltertime, setSelectedfiltertime] = useState([]);
  const [guest, setGuest] = useState(["Below 5", "5-10", "11-15", "Above 15"]);
  const [selectedGuest, setSelectedGuest] = useState([parseData?.guests]);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [center, setCenter] = useState(parseData?.mobileCenter);
  const [loader, setLoader] = useState(true);
  const [time, setTime] = useState(parseData?.time);
  const [guests, setGuests] = useState(parseData?.guests);
  const [suggestSpace, setSuggestSpace] = useState([]);
  const [selectedCityVal, setselectedCityVal] = useState("");
  const [selectedCenterVal, setselectedCenterVal] = useState("");

  let navigate = useNavigate();

  const [queryCenter, setQueryCenter] = useState(parseData?.mobileCenter);
  const [queryCity, setQueryCity] = useState(parseData?.mobileSelectedCity);
  const [queryDate, setQueryDate] = useState(parseData?.mobileDate);
  const [queryGuest, setQueryGuest] = useState(parseData?.guests);
  const [queryTime, setQueryTime] = useState(parseData?.time);
  const [queryAmenities, setQueryAmenities] = useState(
    parseAminities?.aminities
  );
  const [queryParams, setQueryParams] = useState(parseData.queryParams);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    let city_id = searchParams.get("city_id");
    let querydate = searchParams.get("date");
    let center_id = searchParams.get("center_id");
    let guest = searchParams.get("guest");
    let time = searchParams.get("time");
    let amenities = searchParams.get("amenities");

    if (city_id !== undefined && city_id !== null) {
      setSelectedCity(city_id);
      setQueryCity(city_id);
      flag = city_id;
      // getCenterList(city_id);
    }
    if (querydate !== undefined && querydate !== null) {
      setSelectedDate(querydate);
      setQueryDate(querydate);
      if (date == querydate) {
        setDateChange(false);
      } else {
        setDateChange(true);
      }
    }
    if (center_id !== undefined && center_id !== null) {
      setCenter(center_id);
      setQueryCenter(center_id);
    }
    if (guest !== undefined && guest !== null) {
      setGuests(guest);
      setQueryGuest(guest);
      handleGuest(guest);
    }
    if (time !== undefined && time !== null) {
      setQueryTime(time);
      handleFiltertime(time);
    }
    if (time !== undefined && time !== null) {
      setQueryTime(time);
      handleFiltertime(time);
    }
    if (amenities !== undefined && amenities !== null) {
      setSelectedAminities(amenities);
      setQueryAmenities(amenities);
      handleAmenities(amenities);
    }
  }, [searchParams]);
  useEffect(() => {
    if (parseAminities.aminities.length > 0) {
      let tempAmenities = [];

      tempAmenities = parseAminities.aminities?.map((i) => {
        return i.value;
      });
      setQueryAmenities((prevState) => tempAmenities);
    }
  }, [parseAminities?.aminities]);

  useEffect(() => {
    if (window.history.pushState) {
      let newurl;
      if (
        queryCity ||
        queryDate ||
        queryCenter ||
        queryGuest ||
        queryTime ||
        queryAmenities
      ) {
        let checkAminities = queryAmenities.length > 0;
        if (queryParams !== undefined && queryParams !== "") {
          newurl = `?${queryParams && queryParams}?${
            queryCity && `&&city_id=${queryCity}`
          }${queryDate && `&&date=${queryDate}`}${
            queryCenter && `&&center_id=${queryCenter}`
          }${queryGuest && `&&guest=${queryGuest}`}${
            queryTime && `&&time=${queryTime}`
          }${checkAminities === true ? `&&amenities=${queryAmenities}` : ""}
        `;
          window.history.pushState({ path: newurl }, "", newurl);
        } else {
          newurl = `?${queryCity && `&&city_id=${queryCity}`}${
            queryDate && `&&date=${queryDate}`
          }${queryCenter && `&&center_id=${queryCenter}`}${
            queryGuest && `&&guest=${queryGuest}`
          }${queryTime && `&&time=${queryTime}`}${
            checkAminities === true ? `&&amenities=${queryAmenities}` : ""
          }
          `;
          window.history.pushState({ path: newurl }, "", newurl);
        }
        // window.history.pushState({ path: newurl }, "", newurl);
      } else {
        searchParams.delete("city_id");
        searchParams.delete("center_id");
        searchParams.delete("date");
        searchParams.delete("guest");
        searchParams.delete("time");
        searchParams.delete("amenities");
        setSearchParams(searchParams);
      }
    }
    // let newurl = `${queryCity && `&&city_id=${queryCity}`}${
    //   queryDate && `&&date=${queryDate}`
    // }${queryCenter && `&&center_id=${queryCenter}`}${
    //   guests && `&&guest=${guests}`
    // }`;
    // setSearchParams(newurl);
  }, [
    queryCity,
    queryDate,
    queryCenter,
    queryGuest,
    queryTime,
    queryAmenities,
  ]);

  useEffect(() => {
    let location = window.location.href;
    let query_params = location.split("?")[1];
    // console.log(query_params)
    let checkString = true;
    checkString = query_params ? query_params.startsWith("&&") : false;
    if (!checkString) {
      setQueryParams(query_params);
    } else {
      setQueryParams("");
    }
  }, [window.location.href]);

  useEffect(() => {
    let newvar = window.location.pathname;
    let key = newvar.split("filter-page/")[1];
    setAccessKey(key);
  }, [window.location.pathname]);

  useEffect(() => {
    getCityList();
  }, []);

  useEffect(() => {
    format(new Date(), "yyyy-MM-dd");
    const dates = [new Date(selectedDate)];
    dates.sort(compareAsc);
    let datefor = dates[0];
    let tempDate = datefor.toString().split(" ");
    let formeteddate = `${tempDate[0]}, ${tempDate[2]} ${tempDate[1]}, ${tempDate[3]}`;
    setSelectedDate2(formeteddate);
    if (todaydate !== selectedDate) {
      setDateChange(true);
    }
  }, [selectedDate]);

  useEffect(() => {
    if (cityList.length > 0) {
      getCenterList(selectedCity);
      getspacelists(selectedCity);
    }
  }, [
    cityList,
    center,
    selectedCity,
    selectedDate,
    selectedGuest?.[0],
    selectedfiltertime?.[0],
    selectedAminities.length,
  ]);

  useEffect(() => {
    if (cityList.length == 0) {
      getCenterList(selectedCity);
    }

    let centerId = parseInt(center);
    let selectedCityVal = cityList?.find((item) => item?.id === selectedCity);
    let selectedcenterVal = selecteCenter?.find(
      (items) => items?.id === centerId
    );
    setselectedCenterVal(selectedcenterVal);
  }, [center, selectedCity, selectedDate]);

  const getspacelists = async (city) => {
    let params = `city_id=${city}&inventory_type_id=3`;

    bookingStore.getspacelist(params, (response) => {
      if (response?.data?.status === 1) {
        setSelecteSpace(response?.data?.data);
        let centerList = response?.data?.data?.space;
        // setCenterList(centerList);
        if (center == "") {
          setSelecteCenter(centerList);
        }
        // console.log(response?.data?.data)
        setLoader(false);
      } else {
        console.log("error");
        setLoader(false);
      }
    });
  };

  const getCityList = async () => {
    await bookingStore.getCityList((response) => {
      if (response?.data?.status === 1) {
        setCityList(response?.data?.data);
        if (flag == undefined) {
          if (selectedCity === undefined || selectedCity == "") {
            setSelectedCity(response?.data?.data[0].id);
          }
        }
      } else {
        console.log("error");
      }
    });
  };

  // const fetch_data = async (data, delaytimer, orginal) => {
  //   if (data.length > 0) {
  //     setTimeout(async () => {
  //       let item = data[0];
  //       const url = `inventory_id=${item.inventories[0].id}&date=${selectedDate}`;
  //       await bookingStore.getMeetingSlot(url, (response) => {
  //         if (response?.data?.status === 1) {
  //           let responseData = response?.data?.data[0];
  //           // console.log("responseData", response?.data?.data[0], url);
  //           let remaining = data.slice(1);
  //           let orgList = JSON.parse(orginal);
  //           orgList.map((x, index) => {
  //             for (let i = 0; i < x.inventories.length; i++) {
  //               if (x.inventories[0].id === responseData.id) {
  //                 x.inventories[i].meeting_slots = responseData.meeting_slots;
  //               }
  //             }
  //           });

  //           orginal = JSON.stringify(orgList);

  //           setCenterList(orgList);

  //           fetch_data(remaining, delaytimer + 20, orginal);
  //         } else {
  //           console.log("error");
  //         }
  //       });
  //     }, delaytimer);
  //   } else {
  //     setCenterList(JSON.parse(orginal));
  //   }
  // };

  const getCenterList = async (city) => {
    // setLoader(true);
    let pax_start = 0;
    let pax_end = 0;
    let start_time = 0;
    let end_time = 0;

    if (guests?.length > 0) {
      let guestData = guests;
      let tempGuest = guestData;
      if (tempGuest === "Below 5") {
        pax_start = 1;
        pax_end = 4;
      } else if (tempGuest === "5-10") {
        pax_start = 5;
        pax_end = 10;
      } else if (tempGuest === "11-15") {
        pax_start = 11;
        pax_end = 15;
      } else if (tempGuest === "Above 15") {
        pax_start = 15;
        pax_end = 100;
      }
    }
    if (selectedfiltertime?.length > 0) {
      let timeData = selectedfiltertime;
      let tempTime = timeData[0];
      if (tempTime === "8:00-12:00") {
        let temp = tempTime?.split("-");
        start_time = `${selectedDate} 0${temp[0]?.split("am")[0]}:00`;
        end_time = `${selectedDate} ${temp[1]?.split("pm")[0]}:00`;
      } else if (tempTime === "12:00-16:00") {
        let temp = tempTime?.split("-");
        start_time = `${selectedDate} ${temp[0]?.split("pm")[0]}:00`;
        end_time = `${selectedDate} ${temp[1]?.split("pm")[0]}:00`;
      } else if (tempTime === "16:00-20:00") {
        let temp = tempTime?.split("-");
        start_time = `${selectedDate} ${temp[0]?.split("pm")[0]}:00`;
        end_time = `${selectedDate} ${temp[1]?.split("pm")[0]}:00`;
      }
    } else {
      start_time = `${selectedDate} 00:00`;
    }
    let obj = {
      mr_vc: 0,
      lcd: 0,
      projector: 0,
      whiteboard: 0,
    };
    
    if (selectedAminities?.length > 0) {
      let aminiData = selectedAminities;
      aminiData?.map((item) => {

        if (item.value === "VC") {
          obj.mr_vc = 1;
        } else if (item.value === "LCD Screen") {
          obj.lcd = 1;
        } else if (item.value === "Projector") {
          obj.projector = 1;
        } else if (item.value === "Whiteboard") {
          obj.whiteboard = 1;
        }
      });
    }
    let params = `city_id=${city}${obj.lcd == 1 ? `&lcd=${obj.lcd}` : ""}${
      obj.mr_vc == 1 ? `&mr_vc=${obj.mr_vc}` : ""
    }${obj.projector == 1 ? `&projector=${obj.projector}` : ""}${
      obj.whiteboard == 1 ? `&whiteboard=${obj.whiteboard}` : ""
    }${pax_start !== 0 ? `&pax_start=${pax_start}` : ""}${
      pax_end !== 0 ? `&pax_end=${pax_end}` : ""
    }${start_time !== 0 ? `&start_time=${start_time}` : ""}${
      end_time !== 0 ? `&end_time=${end_time}` : ""
    }${center !== "" ? `&space_id=${center}` : ""}`;
    await bookingStore.getCenterList(params, (response) => {
      if (response?.data?.status === 1) {
        let invenotriesId = [];
        let centerList = response?.data?.data?.space;
        // centerList.map((item, index) => {
        //   invenotriesId.push(item.inventories[0].id);
        //   for (let i = 0; i < item.inventories.length; i++) {
        //     item.inventories[i].meeting_slots = [];
        //   }
        // });
        setCenterList(centerList);
        setLoader(false);
        if (centerList.length == 0) {
          getSuggestCenterList(selectedCity);
        }

        // let orglist = JSON.stringify(centerList);

        // fetch_data(centerList, 200, orglist);

        // if (center == "") {
        //   setSelecteCenter(response?.data?.data?.space);
        // }

        // setSelecteSpace(response?.data?.data);
        setLoader(false);
      } else {
        setCenterList([]);
        setSelecteCenter([]);
        setLoader(false);
      }
    });
  };

  // const fetch_dataSuggest = async (data, delaytimer, orginal) => {
  //   if (data.length > 0) {
  //     setTimeout(async () => {
  //       let item = data[0];
  //       const url = `inventory_id=${item.inventories[0].id}&date=${selectedDate}`;
  //       await bookingStore.getMeetingSlot(url, (response) => {
  //         if (response?.data?.status === 1) {
  //           let responseData = response?.data?.data[0];
  //           // console.log("responseData", response?.data?.data[0], url);
  //           let remaining = data.slice(1);
  //           let orgList = JSON.parse(orginal);
  //           orgList.map((x, index) => {
  //             for (let i = 0; i < x.inventories.length; i++) {
  //               if (x.inventories[0].id === responseData.id) {
  //                 x.inventories[i].meeting_slots = responseData.meeting_slots;
  //               }
  //             }
  //           });
  //           orginal = JSON.stringify(orgList);
  //           fetch_dataSuggest(remaining, delaytimer + 20, orginal);
  //         } else {
  //           console.log("error");
  //         }
  //       });
  //     }, delaytimer);
  //   } else {
  //     setSuggestSpace(JSON.parse(orginal));
  //     // setLoader(false);
  //   }
  // };

  const getSuggestCenterList = async (city) => {
    let start_time = 0;
    if (selectedfiltertime?.length > 0) {
      let timeData = selectedfiltertime;
      let tempTime = timeData[0];
      if (tempTime === "8:00-12:00") {
        let temp = tempTime?.split("-");
        start_time = `${selectedDate} 0${temp[0]?.split("am")[0]}:00`;
      } else if (tempTime === "12:00-16:00") {
        let temp = tempTime?.split("-");
        start_time = `${selectedDate} ${temp[0]?.split("pm")[0]}:00`;
      } else if (tempTime === "16:00-20:00") {
        let temp = tempTime?.split("-");
        start_time = `${selectedDate} ${temp[0]?.split("pm")[0]}:00`;
      }
    } else {
      start_time = `${selectedDate} 00:00`;
    }

    let params = `city_id=${city}${
      start_time !== 0 ? `&start_time=${start_time}` : ""
    }`;

    await bookingStore.getCenterList(params, (response) => {
      if (response?.data?.status === 1) {
        let invenotriesId = [];
        let centerList = response?.data?.data?.space;
        setSuggestSpace(centerList);
        setLoader(false);
        // centerList.map((item, index) => {
        //   invenotriesId.push(item.inventories[0].id);
        //   for (let i = 0; i < item.inventories.length; i++) {
        //     item.inventories[i].meeting_slots = [];
        //   }
        // });
        // let orglist = JSON.stringify(centerList);
        // fetch_dataSuggest(centerList, 200, orglist);

        setSelecteSpace(response?.data?.data);
        setLoader(false);
      } else {
        setSuggestSpace([]);
        setLoader(false);
      }
    });
  };

  const getFilterData = async (id) => {
    const newCenters = selecteCenter.filter(
      (selecteCenter) => selecteCenter.id == id
    );
    setCenterList(newCenters);
  };

  const handleAmenities = (item, index) => {
    let tempAmenities = [];
    if (typeof item !== "object") {
      tempAmenities = selectedAminities;

      if (!tempAmenities.includes(item)) {
        tempAmenities.push(item);
      } else {
        tempAmenities.splice(tempAmenities.indexOf(item), 1);
      }
    } else {
      tempAmenities = item?.map((i) => {
        return i;
      });
    }
    setSelectedAminities((prevState) => tempAmenities);
    setQueryAmenities((prevState) => tempAmenities);
    if (tempAmenities.length == 0) {
      getCenterList(selectedCity);
    }
  };

  const handleFiltertime = (item, index) => {
    let tempFilterTime = selectedfiltertime;

    if (!tempFilterTime.includes(item)) {
      if (tempFilterTime.length < 0) tempFilterTime.push(item);
      else {
        tempFilterTime = [];
        tempFilterTime.push(item);
      }
    } else {
      tempFilterTime.splice(tempFilterTime.indexOf(item), 1);
    }
    setSelectedfiltertime((prevState) => tempFilterTime);
    setFiltertime((prevState) => [...filtertime]);
  };

  const handleGuest = (item, index) => {
    let tempGuest = selectedGuest;

    if (!tempGuest.includes(item)) {
      if (tempGuest.length < 0) tempGuest.push(item);
      else {
        tempGuest = [];
        tempGuest.push(item);
      }
    } else {
      tempGuest.splice(tempGuest.indexOf(item), 1);
    }
    setSelectedGuest((prevState) => tempGuest);
    setGuest((prevState) => [...guest]);
    setCenterList([]);
  };

  const handleLeadForm = async (e) => {
    e.preventDefault();
    if (name === "") {
      notify("Please enter name", "danger");
      return;
    }
    if (mobile === "") {
      notify("Please enter mobile number", "danger");
      return;
    }
    if (email === "") {
      notify("Please enter email", "danger");
      return;
    }
    if (selectedCity === "") {
      notify("Please select city", "danger");
      return;
    }
    let payloadData = {
      name: name,
      mobile: mobile,
      email: email,
      city_id: parseInt(selectedCityLead),
      inv_type: 3,
    };
    setLoader(true);
    await bookingStore.getLeadForm(payloadData, (response) => {
      if (response?.data?.status === 1) {
        notify("Thankyou. We've received your enquiry	");
        setName("");
        setMobile("");
        setEmail("");
        setSelectedCityLead("");
        setLoader(false);
      } else {
        notify("Lead submission failed", "danger");
        setLoader(false);
      }
    });
  };

  var settings = {
    dots: true,
    autoplay: true,
    infinite: true,
    speed: 2000,
  };

  const [showFilter, setShowFilter] = useState(false);

  const filterfun = () => {
    if (showFilter) {
      setShowFilter(false);
    } else {
      setShowFilter(true);
    }
  };
  return (
    <>
      <Header accessKey={accessKey} queryParams={queryParams && queryParams} />
      {loader ? (
        <div className="loader"></div>
      ) : (
        <>
          <div className="filter-panel">
            <div className="filter-panel-inner">
              <div className="fpanel-left">
                <ul className="filter-list">
                  <li className="filter-list-item">
                    {selecteSpace?.city_name}
                  </li>
                  {center && (
                    <li className="filter-list-item">
                      {selectedCenterVal?.name}
                    </li>
                  )}
                  {selectedDate2 && (
                    <li className="filter-list-item">{selectedDate2}</li>
                  )}
                  {guests && (
                    <li className="filter-list-item">{guests} Seater</li>
                  )}
                  {time && <li className="filter-list-item">{time}</li>}
                  {selectedAminities.length > 0 && (
                    <li className="filter-list-item">
                      {selectedAminities?.map((i, index) => {
                        return (
                          <>
                            {i.value}
                            {selectedAminities.length !== index + 1 && ", "}
                          </>
                        );
                      })}
                    </li>
                  )}
                </ul>
              </div>
              <div className="fpanel-right" style={{ cursor: "pointer" }}>
                <img
                  src={require("../../assets/images/medit.png")}
                  onClick={() => {
                    filterfun();
                  }}
                  alt="Edit"
                  className="edit-micon"
                />
              </div>
            </div>
            {showFilter && (
              <div className="filter-panel-fields">
                <div className="pt-4">
                  <div className="location-box">
                    <div className="form-group icon-group">
                      <img src={MapIcon} alt="Location" className="map-icon" />
                      <select
                        className="form-control filter-field"
                        id="sel1"
                        value={selectedCity}
                        onChange={(e) => {
                          e.preventDefault();
                          setSelectedCity(e.target.value);
                          setQueryCity(e.target.value);
                          setQueryCenter("");
                          setCenter("");
                          setGuests("");
                          handleGuest("");
                          setTime("");
                          handleFiltertime("");
                          handleAmenities("");
                          setSelectedAminities("");
                          setQueryAmenities("");
                          setLoader(true);
                        }}
                      >
                        {cityList?.map((item) => {
                          return (
                            <>
                              <option
                                className="cityoptionfield"
                                value={item?.id}
                              >
                                {item?.name}
                              </option>
                            </>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                  <div
                    className="date-box"
                    onClick={() => {
                      mobiledateRef.current.showPicker();
                    }}
                  >
                    <div className="form-group icon-group">
                      <img src={DateIcon} alt="Location" className="map-icon" />
                      <input
                        ref={mobiledateRef}
                        data-date-format="DD MMMM YYYY"
                        className="form-control filter-field date"
                        value={selectedDate}
                        onChange={(e) => {
                          if (e.target.value == todaydate) {
                            sessionStorage.setItem(
                              "selectedDate",
                              JSON.stringify(e.target.value)
                            );
                            setQueryDate(e.target.value);
                            setSelectedDate(e.target.value);
                            setQueryCenter("");
                            setDateChange(false);
                          } else {
                            sessionStorage.setItem(
                              "selectedDate",
                              JSON.stringify(e.target.value)
                            );
                            setSelectedDate(e.target.value);
                            setQueryDate(e.target.value);
                            setDateChange(true);
                            setLoader(true);
                          }
                          setCenterList([]);
                        }}
                        type="date"
                        min={todaydate}
                      />
                      <span className="open-button">
                        <img
                          src={require("../../assets/images/down.png")}
                          alt="Date"
                          className="date-icon"
                        />
                      </span>
                      {selectedDate !== "" ? (
                        <p className="date-home">{selectedDate2}</p>
                      ) : (
                        <p className="date-home">{"dd-mm-yyyy"}</p>
                      )}
                    </div>
                  </div>
                  <div className="center-box">
                    <div className="form-group icon-group">
                      <img
                        src={CentreIcon}
                        alt="Location"
                        className="map-icon"
                      />
                      <select
                        className="form-control filter-field"
                        id="sel1"
                        value={center}
                        onChange={(e) => {
                          if (e.target.value !== "") {
                            setCenter(e.target.value);
                            setQueryCenter(e.target.value);
                          } else {
                            setCenter("");
                            setQueryCenter("");
                          }
                          setGuests("");
                          handleGuest("");
                          setTime("");
                          handleFiltertime("");
                          handleAmenities("");
                          setSelectedAminities("");
                          setQueryAmenities("");
                          setLoader(true);
                        }}
                      >
                        <option value="">Select Center</option>
                        {selecteCenter?.map((item) => {
                          return <option value={item?.id}>{item?.name}</option>;
                        })}
                      </select>
                    </div>
                  </div>
                  <div className="d-flex">
                    <div className="center-box mobileview-dblock mr-2">
                      <div className="form-group icon-group mb-0">
                        <select
                          className="form-control mobfield-noicon"
                          id="sel1"
                          value={guests}
                          onChange={(e) => {
                            if (e.target.value !== "") {
                              handleGuest(e.target.value);
                              setGuests(e.target.value);
                              setQueryGuest(e.target.value);
                            } else {
                              setGuests("");
                              setQueryGuest("");
                              handleGuest("");
                            }
                            setLoader(true);
                          }}
                        >
                          <option value="">No. of Guests</option>
                          {guest?.map((item, index) => {
                            return <option value={item}>{item}</option>;
                          })}
                        </select>
                      </div>
                    </div>
                    <div className="center-box mobileview-dblock">
                      <div className="form-group icon-group mb-0">
                        <select
                          className="form-control mobfield-noicon"
                          id="sel1"
                          value={time}
                          onChange={(e) => {
                            if (e.target.value !== "") {
                              handleFiltertime(e.target.value);
                              setTime(e.target.value);
                              setQueryTime(e.target.value);
                            } else {
                              setTime("");
                              handleFiltertime("");
                              setQueryTime("");
                            }
                            setLoader(true);
                          }}
                        >
                          <option value="">Time</option>
                          {filtertime?.map((item, index) => {
                            return <option value={item}>{item}</option>;
                          })}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="center-box mobileview-dblock selectame">
                    <div className="form-group icon-group centreIcon-container">
                      <Select
                        isMulti={true}
                        placeholder="Select Amenities"
                        options={amenitiesArray}
                        className={"filter-field"}
                        defaultValue={selectedAminities}
                        onChange={(e) => {
                          if (e !== "") {
                            handleAmenities(e);
                          } else {
                            handleAmenities("");
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="filter-container">
            <section className="booking-listing-section">
              <div className="container">
                <div className="row">
                  <div className="col-sm-12">
                    <div className="container listing-container">
                      <p
                        className="nodatafound-subheading text-left mb-3"
                        style={{ color: "#5b5c5e" }}
                      >
                        Available Results
                      </p>
                      {centerList?.length > 0 ? (
                        centerList?.map((item, index) => {
                          return (
                            <>
                              <CentersListView
                                // key={index}
                                item={item}
                                date={selectedDate}
                                navigate={navigate}
                                accessKey={accessKey}
                                searchParamsVal={queryParams}
                                changeDate={dateChange}
                                cityid={selectedCity}
                                pickedDate={selectedDate}
                              />
                            </>
                          );
                        })
                      ) : (
                        <div>
                          <div className=" mobileview-dblock ">
                            <p className="nodata-heading text-left">
                              Oops,
                              <br /> selected space unavailable.
                            </p>
                            <p className="nodatafound-subheading text-left mb-3">
                              EXPLORE ALTERNATIVES.
                            </p>
                          </div>
                          {suggestSpace?.map((item, index) => {
                            return (
                              <>
                                <CentersListView
                                  key={item.id}
                                  item={item}
                                  date={selectedDate}
                                  navigate={navigate}
                                  accessKey={accessKey}
                                  changeDate={dateChange}
                                  cityid={selectedCity}
                                  pickedDate={selectedDate}
                                />
                              </>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </>
      )}
    </>
  );
};

export default FilterPage;
